export default __webpack_public_path__ + "img/InterDisplay-Black_a307e08.woff2";